import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const SessionVerify = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const clientHash = localStorage.getItem("@aqvex/clientHash");
  const sellerId = localStorage.getItem("@aqvex/sellerId");

  useEffect(() => {
    if (!user) {
      navigate(`/catalogo/${clientHash}/${sellerId}`);
    }
  }, [user, navigate]);

  return null;
};

export default SessionVerify;
